<div class="d-flex align-items-center justify-content-between mb-2">
    <h4>General Settings</h4>

    <div class="d-flex">
        <button
            class="btn btn-outline-secondary mb-1 me-2"
            type="button"
            *ngIf="false && !disabled && !undoDisable"
            (click)="undo()"
        >
            {{ 'workflow-form.undoLabel' | translate }}
        </button>

        <button
            class="btn btn-outline-primary mb-1"
            type="button"
            *ngIf="!disabled"
            [disabled]="saveDisable"
            (click)="onSave.emit(generalSettingsForm.value)"
        >
            <icon-save />
            {{ 'workflow-form.saveLabel' | translate }}
        </button>
    </div>
</div>

<form [formGroup]="generalSettingsForm">
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">Main Settings</h5>

            <div class="row gx-3">
                <div class="col-md-6 form-group">
                    <label class="form-label">
                        {{ 'general-campaign-form.nameLabel' | translate }}
                    </label>

                    <input 
                        formControlName="name" 
                        name="name"
                        id="name" 
                        [disabled]="disabled"
                        [placeholder]="'general-campaign-form.namePlaceholder' | translate" 
                        type="text"
                        class="form-control"
                        [ngClass]="generalSettingsForm.get('name').dirty && generalSettingsForm.get('name').invalid ?'invalid-field' : ''"
                    />
                </div>

                <div class="col-md-6 form-group">
                    <label class="form-label form-label-required">
                        {{ 'general-campaign-form.senderNameLabel' | translate }}
                    </label>

                    <input 
                        formControlName="senderName" 
                        name="senderName"
                        id="senderName" 
                        [disabled]="disabled"
                        [placeholder]="'general-campaign-form.senderNamePlaceholder' | translate" 
                        type="text"
                        class="form-control"
                        [class.invalid-field]="generalSettingsForm.get('senderName').dirty && generalSettingsForm.get('senderName').invalid"
                    />
                </div>
            </div>

            <div class="row gx-3">
                <div class="form-group">
                    <label class="form-label">
                        {{ 'general-campaign-form.methodsLabel' | translate }}
                    </label>

                    <div
                        class="no-valid-lbl"
                        *ngIf="generalSettingsForm.get('methods').dirty && generalSettingsForm.get('methods').invalid"
                    >
                        Either email or sms options must be checked
                    </div>

                    <div>
                        <p-checkbox
                            class="me-4 mb-1"
                            [disabled]="disabled"
                            [label]="'general-campaign-form.emailLabel' | translate"
                            value="email"
                            formControlName="methods"
                            (onChange)="changeMethods()"
                        />

                        <p-checkbox
                            class="me-4 mb-1"
                            [disabled]="disabled"
                            [label]="'general-campaign-form.smsLabel' | translate"
                            value="sms"
                            formControlName="methods"
                            (onChange)="changeMethods()"
                        />
                    </div>
                </div>
            </div>

            <div class="row gx-3">
                <div class="col-md-6 form-group">
                    <label class="form-label">
                        {{ 'general-campaign-form.quotaLabel' | translate }}
                    </label>

                    <div
                        class="no-valid-lbl"
                        *ngIf="generalSettingsForm.get('quota').value > allowedQuota"
                    >
                        Quota can not be higher than the allowed in location configuration
                    </div>

                    <input 
                        formControlName="quota" 
                        name="quota"
                        id="quota" 
                        [disabled]="disabled"
                        placeholder="1" 
                        min="1"
                        [max]="allowedQuota"
                        type="number"
                        pKeyFilter="pint"
                        onkeypress="return value.length == 0 ? event.key == 0 ? false : event.key :  event.key"
                        class="form-control"
                        [class.invalid-field]="generalSettingsForm.get('quota').dirty && (generalSettingsForm.get('quota').value > allowedQuota)"
                    />
                </div>

                <div class="col-md-6 form-group">
                    <label class="form-label" for="stopCampaign">
                        {{ 'general-campaign-form.stopCampaignLabel' | translate }}
                    </label>

                    <p-dropdown
                        class="p-dropdown-dark"
                        name="stopCampaign"
                        [disabled]="disabled"
                        [options]="stopCampaignRemindersOptions$ | async"
                        formControlName="stopCampaign"
                    />
                </div>
            </div>

            <div class="row gx-3">
                <div class="col-md-6 form-group">
                    <label class="form-label">
                        {{ 'general-campaign-form.colorLabel' | translate }}
                    </label>

                    <color-picker
                        [hex]="generalSettingsForm.value.color | rgbToHex"
                        (onChange)="changeColorComplete($event.hex)"
                    />
                </div>

                <div class="col-md-6 form-group">
                    <label class="form-label" for="stopCampaign">
                        {{ 'workflow-form.enableLabel' | translate }}
                    </label>

                    <p-inputSwitch 
                        formControlName="enableSentimentCheck"
                        (onChange)="handleSentimentChange($event)" 
                        name="enableSentimentCheck" 
                        id="enableSentimentCheck" 
                    />
                </div>
            </div>

            <div class="row gx-3">
                <div class="col-md-6 form-group">
                    <label class="form-label">{{ 'general-campaign-form.daysDuplicateLabel' | translate }}</label>

                    <div
                        class="no-valid-lbl"
                        *ngIf="generalSettingsForm.get('daysForDuplicates').value < 1"
                    >
                        Days for duplicates can not be less than 1
                    </div>

                    <input 
                        formControlName="daysForDuplicates" 
                        name="daysForDuplicates"
                        id="daysForDuplicates" 
                        placeholder="Greater than or equal to 1" 
                        type="number"
                        min="1"
                        [disabled]="disabled"
                        pKeyFilter="pint"
                        class="form-control"
                    />
                </div>

                <div *ngIf="generalSettingsForm.value.enableSentimentCheck" class="col-md-6 form-group">
                    <label class="form-label" for="stopCampaign">
                        {{ 'workflow-form.sentimentCheckTypeLabel' | translate }}
                    </label>

                    <div class="workflow-content">
                        <button type="button" [disabled]="disabled" class="sc-btn" (click)=sentimentCheckChanged(sentimentCheck.Thumbs) [ngClass]="generalSettingsForm.value.sentimentCheckType == sentimentCheck.Thumbs ? 'sc-selected' : ''">
                            <img class="img-btn" src="./assets/images/sentimentCheck/thumbsbutton.png">
                        </button>
                        <button type="button" [disabled]="disabled" class="sc-btn" style="margin-left: 50px" (click)=sentimentCheckChanged(sentimentCheck.Stars) [ngClass]="generalSettingsForm.value.sentimentCheckType == sentimentCheck.Stars ? 'sc-selected' : ''">
                            <img class="img-btn" src="./assets/images/sentimentCheck/starsButton.png">
                        </button>
                        <button type="button" [disabled]="disabled" class="sc-btn" style="margin-left: 50px" (click)=sentimentCheckChanged(sentimentCheck.Faces) [ngClass]="generalSettingsForm.value.sentimentCheckType == sentimentCheck.Faces ? 'sc-selected' : ''">
                            <img class="img-btn" src="./assets/images/sentimentCheck/facesButton.png">
                        </button>
                    </div>
                </div>

                <div
                    *ngIf="generalSettingsForm.value.enableSentimentCheck && generalSettingsForm.value.sentimentCheckType != sentimentCheck.Thumbs && generalSettingsForm.value.sentimentCheckType != undefined"
                    class="col-12 form-group"
                >
                    <div class="d-flex align-items-center mb-2">
                        <label class="form-label mb-0">Send to review sites on:</label>
                        <div
                            class="d-flex align-items-center justify-content-center"
                            ngbTooltip="{{ 'workflow-form.sentimentCheckSettingsTooltip' | translate }}"
                        >
                            <i class="fas info-icon fa-info-circle"></i>
                        </div>
                    </div>

                    <div
                        *ngIf="generalSettingsForm.value.sentimentCheckType == sentimentCheck.Faces"
                        role="radiogroup"
                        aria-label="Send to review sites on"
                    >
                        <div class="radio-button-container">
                            <p-radioButton
                                name="sentimentCheckSettings"
                                inputId="neutralReview"
                                [disabled]="disabled"
                                [value]="sentimentCheckSettings.neutralReview"
                                formControlName="sentimentCheckSettings"
                                label="Neutral or Happy Face"
                            />
                        </div>

                        <div class="radio-button-container">
                            <p-radioButton
                                name="sentimentCheckSettings"
                                inputId="onlyHappy"
                                [disabled]="disabled"
                                [value]="sentimentCheckSettings.onlyHappy"
                                formControlName="sentimentCheckSettings"
                                label="Happy Face Only"
                            />
                        </div>
                    </div>

                    <div
                        *ngIf="generalSettingsForm.value.sentimentCheckType == sentimentCheck.Stars"
                        role="radiogroup"
                        aria-label="Send to review sites on"
                    >
                        <div class="radio-button-container">
                            <p-radioButton
                                name="sentimentCheckSettings"
                                inputId="threeForReview"
                                [disabled]="disabled"
                                [value]="sentimentCheckSettings.threeForReview"
                                formControlName="sentimentCheckSettings"
                                label="3 stars or more"
                            />
                        </div>

                        <div class="radio-button-container">
                            <p-radioButton
                                name="sentimentCheckSettings"
                                inputId="fourForReview"
                                [disabled]="disabled"
                                [value]="sentimentCheckSettings.fourForReview"
                                formControlName="sentimentCheckSettings"
                                label="4 stars or more"
                            />
                        </div>

                        <div class="radio-button-container">
                            <p-radioButton
                                name="sentimentCheckSettings"
                                inputId="fiveForReview"
                                [disabled]="disabled"
                                [value]="sentimentCheckSettings.fiveForReview"
                                formControlName="sentimentCheckSettings"
                                label="5 stars only"
                            />
                        </div>
                    </div>
                </div>

                <div *ngIf="!generalSettingsForm.value.enableSentimentCheck" class="col-md-6 form-group">
                    <label class="form-label mb-3" for="enablePrivateFeedback">
                        {{'general-campaign-form.enablePrivateFeedback' | translate}}
                    </label>

                    <p-inputSwitch 
                        formControlName="enablePrivateFeedback"
                        [disabled]="disabled"
                        name="enablePrivateFeedback" 
                        id="enablePrivateFeedback" 
                    />
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-body">
            <h5 class="card-title">Schedule Settings</h5>

            <div class="row gx-3">
                <div class="d-flex">
                    <label class="form-label">
                        {{ 'general-campaign-form.delayLabel' | translate }}
                    </label>
                </div>

                <div class="d-flex">
                    <div class="form-group me-sm-3 me-md-4">
                        <label class="form-label">
                            <small>{{ 'general-campaign-form.emailOpt' | translate }}</small>
                        </label>

                        <ngb-timepicker
                            [formControl]="generalSettingsForm.controls['delayEmail']"
                            [disabled]="disabled"
                            [minuteStep]=5
                            size="small"
                        />
                    </div>

                    <div class="form-group me-sm-3 me-sm-4">
                        <label class="form-label">
                            <small>{{ 'general-campaign-form.SMSOpt' | translate }}</small>
                        </label>

                        <ngb-timepicker
                            [formControl]="generalSettingsForm.controls['delaySMS']"
                            [disabled]="disabled"
                            [minuteStep]=5
                            size="small"
                        />
                    </div>
                </div>
            </div>

            <div class="row" formGroupName="schedule">
                <div class="d-flex">
                    <label class="form-label">
                        {{ 'general-campaign-form.scheduleLabel' | translate }}
                    </label>
                </div>

                <div *ngIf="generalSettingsForm.get('schedule').get('days').invalid" class="no-valid-lbl">
                    Select at least one day
                </div>

                <div class="pt-3">
                    <p-checkbox
                        class="me-4 mb-2"
                        [disabled]="disabled"
                        [label]="'general-campaign-form.sunday' | translate"
                        [value]="days.Sunday"
                        formControlName="days"
                    />

                    <p-checkbox
                        class="me-4 mb-2"
                        [disabled]="disabled"
                        [label]="'general-campaign-form.monday' | translate"
                        [value]="days.Monday"
                        formControlName="days"
                    />

                    <p-checkbox
                        class="me-4 mb-2"
                        [disabled]="disabled"
                        [label]="'general-campaign-form.tuesday' | translate"
                        [value]="days.Tuesday"
                        formControlName="days"
                    />

                    <p-checkbox
                        class="me-4 mb-2"
                        [disabled]="disabled"
                        [label]="'general-campaign-form.wednesday' | translate"
                        [value]="days.Wednesday"
                        formControlName="days"
                    />

                    <p-checkbox
                        class="me-4 mb-2"
                        [disabled]="disabled"
                        [label]="'general-campaign-form.thursday' | translate"
                        [value]="days.Thursday"
                        formControlName="days"
                    />

                    <p-checkbox
                        class="me-4 mb-2"
                        [disabled]="disabled"
                        [label]="'general-campaign-form.friday' | translate"
                        [value]="days.Friday"
                        formControlName="days"
                    />

                    <p-checkbox
                        class="me-4 mb-2"
                        [disabled]="disabled"
                        [label]="'general-campaign-form.saturday' | translate"
                        [value]="days.Saturday"
                        formControlName="days"
                    />
                </div>

                <div class="d-flex mt-4">
                    <label class="form-label">
                        {{ 'general-campaign-form.timeRangeLabel' | translate }}
                    </label>
                </div>

                <div class="d-flex flex-wrap">
                    <div class="form-group me-sm-3 me-md-4">
                        <label class="form-label">
                            <small>{{ 'general-campaign-form.startTimeLabel' | translate }}</small>
                        </label>

                        <ngb-timepicker
                            [disabled]="disabled"
                            [formControl]="startTime"
                            size="small"
                            [minuteStep]=15
                            meridian="true"
                        />
                    </div>

                    <div class="form-group me-sm-3 me-md-4">
                        <label class="form-label">
                            <small>{{ 'general-campaign-form.endTimeLabel' | translate }}</small>
                        </label>

                        <ngb-timepicker
                            [disabled]="disabled"
                            [formControl]="endTime"
                            [minuteStep]=15
                            size="small"
                            meridian="true"
                        />
                    </div>

                    <div class="form-group me-sm-4 me-md-4">
                        <label class="form-label">
                            <small>{{ 'general-campaign-form.timeZoneLabel' | translate }}</small>
                        </label>

                        <div class="d-flex flex-wrap mt-4">
                            <div class="me-3" style="width: 100px" *ngIf="false">
                                <p-dropdown
                                    [disabled]="disabled"
                                    [options]="timeZonesUSA"
                                    (onChange)="changeTimeZonesList($event)"
                                    optionLabel="label"
                                />
                            </div>

                            <div style="width: 200px">
                                <p-autoComplete 
                                    #tzAutoComplete
                                    [completeOnFocus]="true"
                                    [disabled]="disabled"
                                    [dropdown]="true"
                                    [forceSelection]="true"
                                    [suggestions]="filteredTimeZones" 
                                    (completeMethod)="search($event)"
                                    (onDropdownClick)="tzAutoComplete.clear(); search({ query: '' }); $event.target.select()"
                                    (onFocus)="$event.target.select()"
                                    dropdownMode="current"
                                    formControlName="timeZone"
                                    field="name"
                                >
                                    <ng-template let-filteredTimeZones pTemplate="item">
                                        <div class="ui-helper-clearfix">
                                            <span class="ms-3">
                                                {{filteredTimeZones.name}}
                                            </span>
                                        </div>
                                    </ng-template>
                                </p-autoComplete>
                            </div>
                        </div>

                        <div
                            class="no-valid-lbl"
                            *ngIf="generalSettingsForm.get('schedule').get('timeZone').invalid"
                        >
                            Select a time zone
                        </div>
                    </div>
                </div>

                <div *ngIf="validateEndTime()" class="no-valid-lbl" style="margin-top: -10px">
                    End time cannot be less than the start time
                </div>
            </div>
        </div>
    </div>
</form>
